import { useAATheme } from "./AAThemeContext";
import IconButton, { Variant } from "./IconButton";

const DarkModeToggle = ({ variant = "light" }: { variant?: Variant }) => {
  const { isDarkMode, toggleDarkMode } = useAATheme();
  return (
    <IconButton
      variant={variant}
      className={isDarkMode ? "bi-moon-fill" : "bi-sun-fill"}
      tooltip="Toggle dark mode"
      onClick={toggleDarkMode}
    />
  );
};

export default DarkModeToggle;
